import * as path from 'path';
import * as os from 'os';

export default {
  auth: {
    domain: 'wildmoose.us.auth0.com',
    clientId: '47dPn4CDmqcX3LzDs07roXuSysZdftLX',
    audience: 'https://api.wildmoose.ai/mcp',
  },
  keytar: {
    service: 'wildmoose-oauth',
    tokens: 'tokens',
  },
  configDir: path.join(
    process.env.XDG_CONFIG_HOME ?? path.join(os.homedir(), '.config'),
    'moose-cli'
  ),
  apiUrl: process.env.API_URL ?? 'https://api.wildmoose.ai',

  mcp: {
    defaultPort: process.env.MCP_PORT ?? 3010,
    serverName: process.env.MCP_SERVER_NAME ?? 'moose-mcp-server',
    version: process.env.MCP_VERSION ?? '0.0.0',
  },
};
